import BLOG_ENTRY_QUERY from 'queries/blog/blogEntry';
import client from 'utils/apolloClient';

// Date formatting
import dateFormat from 'date-fns/format';
import isSameDay from 'date-fns/isSameDay';
import isDateAfter from 'date-fns/isAfter';
import { da } from 'date-fns/locale';

const locale = { locale: da };

export async function getBlogEntryBySlug(slug) {
    const result = await client.query({ query: BLOG_ENTRY_QUERY, variables: { slug } });

    if (result.data.blogEntries && result.data.blogEntries.length > 0) {
        return result.data.blogEntries[0];
    }
}

export const getEventDate = (entry, noPrefix = false) => {
    if (!entry.event_date_start) {
        return dateFormat(new Date(entry.date), 'PPPp', locale);
    }
    const dateStart = new Date(entry.event_date_start);
    const dateEnd = entry.event_date_end ? new Date(entry.event_date_end) : undefined;
    let prefix = isDateAfter(new Date(), dateStart) ? 'Afholdt: ' : 'Afholdes: ';
    prefix = noPrefix ? '' : prefix;

    if (isDateAfter(new Date(), dateStart)) {
        return `${prefix}${dateFormat(dateStart, 'PPPp', locale)}`;
    }

    if (dateStart && !dateEnd) {
        return `${prefix}${dateFormat(dateStart, 'dd. MMMM kk:mm', locale)}`;
    }

    if (dateStart && dateEnd) {
        if (isSameDay(dateStart, dateEnd)) {
            return `${prefix}${dateFormat(dateStart, 'dd. MMMM kk:mm', locale)} - ${dateFormat(dateEnd, 'kk:mm', locale)}`;
        }
        return `${prefix}${dateFormat(dateStart, 'dd. MMMM', locale)} til ${dateFormat(dateEnd, 'dd. MMMM', locale)}`;
    }
};
